import { createReducer } from "@reduxjs/toolkit";
import { IWorkflowUnsetTypesState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  state: StoreState.None,
  lastLoaded: undefined,
  data: [],
} as IWorkflowUnsetTypesState;

export const workflowUnsetTypesReducer = createReducer(
  initialState,
  (builder) =>
    builder
      .addCase(actions.workflowUnsetTypesFetchRequest, (state) => ({
        ...state,
        state: StoreState.Loading,
      }))
      .addCase(actions.workflowUnsetTypesFetchSuccess, (state, action) => ({
        ...state,
        state: StoreState.Loaded,
        lastLoaded: new Date(),
        data: action.payload,
      }))
      .addCase(actions.workflowUnsetTypesFetchError, (state) => ({
        ...state,
        state: StoreState.Error,
      }))
      .addCase(actions.workflowUnsetTypesReset, () => initialState)
      .addCase(STORAGE_RESET, () => initialState)
);
